import { EACCEPTED_AUDIO_FORMATS } from 'app/types/enums/EACCEPTED_AUDIO_FORMATS';

export function isRepositoryAudioFile(fileName: string): boolean {
  const extension = `.${(fileName.split('.').pop() ?? '').toLowerCase()}`;
  return EACCEPTED_AUDIO_FORMATS.includes(extension);
}
